import type { ReactNode } from 'react';
import { useAuthStore, type AuthState } from '@flexibilitypay/shared';

export type Role = 'PSP_ADMIN' | 'PSP_OPERATOR' | 'PLATFORM_ADMIN';

/**
 * (Backfill automático — agregar descripción)
 *
 * @taskId T060
 * @see functional/Specs/specs_cycle-2.md HU-11-FE
 */
export interface RoleGateProps {
  allow: Role | Role[];
  children: ReactNode;
  fallback?: ReactNode;
}

const selectRole = (state: AuthState) => state.role;

export function RoleGate({ allow, children, fallback = null }: RoleGateProps) {
  const role = useAuthStore(selectRole);
  const allowed = Array.isArray(allow) ? allow : [allow];
  if (!role || !allowed.includes(role as Role)) {
    return <>{fallback}</>;
  }
  return <>{children}</>;
}
